//Polyfill for startsWith for Internet Explorer
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(searchString, position){
        return this.substr(position || 0, searchString.length) === searchString;
    };
}

function createReCaptcha(reCaptchaPubKey, id) {
    Recaptcha.create(reCaptchaPubKey, id, {
        theme: "clean",
        custom_translations: {
            instructions_visual: ACC.instructionsVisualReCaptcha
        }
    });
}


function submitAlertEmailCreation(url) {
    var validForm = jQuery("#FormStockAlert").validationEngine('validate');

    if (validForm == true) {
        jQuery.ajax({
            type: "POST",
            data: jQuery("#FormStockAlert").find(
                "input[type='hidden'], :input:not(:hidden)").serialize(),
            url: url
        }).done(function (data) {
                jQuery("#FormStockAlert #globalMessages").html(data);
                if (jQuery("#globalMessages > .information_message").hasClass(
                        "positive")) {
                    jQuery("#FormStockAlert").find('.first').remove();
                    jQuery("#FormStockAlert").find('.last').show();
                }

        }).fail(function () {
                jQuery("#FormStockAlert #globalMessages").html('Sorry, an error has occured');
        });
    }
}


jQuery(document).ready(function () {
    bindCreateUpdateAddress();

    jQuery("#submitForgottenPassword").click(function (event) {
        event.preventDefault();
        jQuery("#messageErrors").html('');
        jQuery.ajax({
            type: "POST",
            data: jQuery("#ForgottenPassword").serialize(),
            url: jQuery("#ForgottenPassword").attr('action') + "/validate"
        }).done(function (data) {
                if (data == "OK") {
                    jQuery("#ForgottenPassword").submit();
                } else {
                    jQuery("#messageErrors").html(data);
                }
        }).fail(function () {
                jQuery("#messageErrors").html('Sorry, an error has occured');
        });
    });

    jQuery("#btn-mood").click(function (event) {

        var op1 = $('#select-humeur').val(),
            op2 = $('#select-produit').val(),
            op3 = $('#select-pour').val();
        if (op1 == "" || op2 == "" || op3 == "") {
            var selectModal = '#ModalMoodSearch';
            $(selectModal).show();
            $(selectModal).modal();
        }

    });

    jQuery(document).ready(function ($) {
        $('#addDocLanguage').closest('form').trigger('submit');
    });

    $('#addDocSelector').submit(function (e) {
        e.preventDefault();
        jQuery.ajax({
            data: $('#addDocSelector').serialize(),
            url: $('#addDocSelector').attr('action'),
        }).done(function (html) {
            $("#ScrollProductDoc").html(html);
            //Analytic.bindAllEvents($("#ScrollProductDoc"));
        });
    });

    displyClaimDisclaimer();

});

function displyClaimDisclaimer() {
    $(function () {
        $(".claim").tooltip({
            track: true,
            items: "p",
            content: function () {
                var claimDisclaimer = $(this).closest(".main-claim").find("div.claim-disclaimer").text();
                return claimDisclaimer;
            },
            show: {
                effect: "slideDown",
                delay: 250
            }
        });
    });
};
$('#addDocLanguage').change(function () {
    $(this).closest('form').trigger('submit');
});

/** reapply style after dom content load */
$(function(){
    var elem = $('.side-menu-level2');
    elem.on('click', reapplyStyle);
});

function reapplyStyle() {
    var elems = $('.with-pic');
    elems.each(function () {
        var that = $(this);
        that.removeClass('with-pic');
        that.addClass('with-pic');
    });
    console.log('Done.');
}
/** reapply style after dom content load end*/



/* REPARABILITY PAGE */

//Autocomplete show widget Search
$(".search-area-reparability .search form #search-filter_reparability").autocomplete().autocomplete("widget").appendTo('.search-area-reparability .search');


jQuery(document).ready(function () {
	var productRef =  getURLParameter("ref");
    if(productRef != null) {
        $("#search-filter_reparability").val(productRef);
    }
    $("#search_form_reparability").submit(function (event) {
        searchAjax();
        $(".AjaxaReparabilityResult").hide();
        $(".notfound-reparable").hide();
        event.preventDefault();
    });
});

$(window).on('load',function () {
	var productRef =  getURLParameter("ref");
	if(productRef != null) {
        $("#search-filter_reparability").submit();
    }
});

function getURLParameter(sParam)
{
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split('&');
    for (var i = 0; i < sURLVariables.length; i++)
    {
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] == sParam)
        {
            return sParameterName[1];
        }
    }
    return null;
}


document.addEventListener("DOMContentLoaded", function () {
    var element = document.getElementById("search-filter_reparability");
    if (element != null) {
        element.oninvalid = function (e) {
            e.target.setCustomValidity("");
            if (!e.target.validity.valid) {
                e.target.setCustomValidity(reparabilityValideMessage);
            }
        };
        element.oninput = function (e) {
            e.target.setCustomValidity("");
        };
    }
});

function searchAjax() {
    /**
     *
     * @type {*|jQuery}
     */
    var data = $("#search-filter_reparability").val();
    $.ajax({
        type: "GET",
        url: "productRef/search?text=" + data,
        timeout: 100000
    }).done(function (data) {
            $(".AjaxaReparabilityResult").hide();
            $(".notfound-reparable").hide();
            if (data.flag == "found") {
                if (data.product.reparabilityIncluded == 'YES') {
                    $(".AjaxaReparabilityResult").hide();
                    /**
                     *
                     * @type {string}
                     */
                    var respContent = "";
                    respContent += "<div class='resultReparability' >";
                    if (data.product.images != null) {
                        respContent += " <div class='mediaReparability'><img src=" + data.product.images[0].url + "></div> ";
                    }
                    respContent += " <div class='detailReparability'> ";
                    respContent += " <div class='product-name'>" + data.product.name + "</div> ";
                    if (data.product.commercialCode != null) {
                        respContent += " <span class='ref'> " + reparabilityProductRef + data.product.commercialCode.toUpperCase() + "</span> ";
                    }

                    respContent += " <div class='resultsReparability reparable'> ";
                    respContent += " <span class='title' >" +data.repairabilityStatusMessage+ "</span>";
                    respContent += " <span class='repareMessage1' >" + data.repairabilityStatusDescriptionParagraphs[0]  + "</span>";
                    respContent += " <span class='repareMessage2' >" + data.repairabilityStatusDescriptionParagraphs[1]  + "</span>";
                    respContent += " <span class='repareNotice' >" + reparabilityNotice + "</span>";
                    respContent += " <a href='" + reparabilityUrlFinfRepairs + "' class='btn btn-action findStoresNearMe' >" + reparabilitybuttonFinfRepairs + "</a>";
                    respContent += " </div>";
                    respContent += " </div> ";
                    respContent += " <div style='display: block;clear: both;'>";
                    respContent += " </div>";
                    respContent += " </div>";
                    respContent += " </div>";

                    $(".AjaxaReparabilityResult").html(respContent);
                    $(".AjaxaReparabilityResult").slideDown("slow", function () {
                        console.log("End Ajax");
                    });
                } else if (data.product.reparabilityIncluded == 'NO'){
                    $(".AjaxaReparabilityResult").hide();
                    /**
                     *
                     * @type {string}
                     */
                    var respContent = "";
                    respContent += "<div class='resultReparability' >";
                    if (data.product.images != null) {
                        respContent += " <div class='mediaReparability'><img src=" + data.product.images[0].url + "></div> ";
                    }
                    respContent += " <div class='detailReparability'> ";
                    respContent += " <div class='product-name'>" + data.product.name + "</div> ";
                    if (data.product.commercialCode != null) {
                        respContent += " <span class='ref'> " + reparabilityProductRef + data.product.commercialCode.toUpperCase() + "</span> ";
                    }

                    respContent += " <div class='resultsReparability non-reparable'> ";
                    respContent += " <span class='title' >" +data.repairabilityStatusMessage+ "</span>";
                    respContent += " <span class='repareMessage1 ' >" + data.repairabilityStatusDescriptionParagraphs[0] + "</span>";
                    respContent += " <span class='repareMessage2' >" + data.repairabilityStatusDescriptionParagraphs[1] + "</span>";
                    respContent += " <a href='" + reparabilityUrlFinfRepairs + "' class='btn btn-action findStoresNearMe' >" + reparabilitybuttonFinfRepairs + "</a>";
                    respContent += " </div>";
                    respContent += " </div> ";
                    respContent += " <div style='display: block;clear: both;'>";
                    respContent += " </div>";
                    respContent += " </div>";
                    respContent += " </div>";

                    $(".AjaxaReparabilityResult").html(respContent);
                    $(".AjaxaReparabilityResult").slideDown("slow", function () {
                        console.log("End Ajax");
                    });
                }
                else {
                    $(".AjaxaReparabilityResult").hide();
                    var respContent = "";
                    respContent += "<div class='resultReparability' >";
                    if (data.product.images != null) {
                        respContent += " <div class='mediaReparability'><img src=" + data.product.images[0].url + "></div> ";
                    }
                    respContent += " <div class='detailReparability'> ";
                    respContent += " <div class='product-detail '>";
                    respContent += " <div class='product-name'>" + data.product.name + "</div> ";
                    if (data.product.commercialCode != null) {
                        respContent += " <span class='ref'> " + reparabilityProductRef + data.product.commercialCode.toUpperCase() + "</span> ";
                    }
                    respContent += " <div class='resultsReparability non-reparable'> ";
                    respContent += " <span class='title' >" + reparabilityNotDefinedMessage + "</span>";
                    respContent += " <span class='repareMessage1 ' >" + reparabilityNotDefinedParagraph1 + "</span>";
                    respContent += " <span class='repareMessage2' >" + reparabilityNotDefinedParagraph2 + "</span>";
                    respContent += " <a href='" + reparabilityUrlFinfRepairs + "' class='btn btn-action findStoresNearMe' >" + reparabilitybuttonFinfRepairs + "</a>";
                    respContent += " </div>";
                    respContent += " </div>";
                    respContent += " </div> ";
                    respContent += " <div style='display: block;clear: both;'>";
                    respContent += " </div>";
                    $(".AjaxaReparabilityResult").html(respContent);
                    $(".AjaxaReparabilityResult").slideDown("slow", function () {
                        console.log("End Ajax");
                    });
                }

            } else if (data.flag == "foundAtComeSite") {
            	Modal.displayReparabilityModal(data);
            } else {
                $(".notfound-reparable").hide();
                $(".reference-finder").show();
                /**
                 *
                 * @type {string}
                 */
                var respContent = "";
                respContent += " <span>";
                respContent += " <p>" + reparabilityNotFound + "</p>";
                respContent += " </span>";
                $(".notfound-reparable").html(respContent);
                $(".notfound-reparable").slideDown("slow");
            }
    }).fail(function (e) {
            console.log("ERROR: ", e);
    }).done( function (e) {
            console.log("DONE");
    });
}
/* END REPARABILITY PAGE */

$(document).ready(function () {
    // autocomplete detached Pieces
    var productCode = $("#detachedPieceForm #productCode").val();
    $(function () {
        $("#detachedPieceForm #accessoryCode").autocomplete({
            source: function (request, response) {
                $.ajax({
                    url: ACC.config.contextPath + "/exploded-view/" + productCode + "/detail-exp-view/auto-compelte",
                    type: "GET",
                    dataType: "json",
                    data: {term: request.term}
                }).done(function (data) {
                        console.log(data);
                        response(data);
                });
            }
        });
    });
});

jQuery(document).ready(function() {
  //Display offers popin
  var displayTimeout=$(".offer-popin").data("timeout")*1000;
  setTimeout(function(){
    if ($(".offer-popin").length > 0) {
      $(".offer-popin").modal();
      Modal.show();
    }
  }, displayTimeout);
  //Display offers popin
});

$(document).ready(function () {
	if($(window).width() > 768){
		var marginLeft = -($(".offer-popin").width())/2;
		$(".offer-popin").css("margin-left",marginLeft);
	}
	else{
		$(".offer-popin").css("margin-left","");
	}
});

$(window).resize(function () {
	if($(window).width() > 768){
		var marginLeft = -($(".offer-popin").width())/2;
		$(".offer-popin").css("margin-left",marginLeft);
	}
	else{
		$(".offer-popin").css("margin-left","");
	}
});


